module.exports = __webpack_public_path__ + "static/media/2.cc1a5562.svg";